import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAdmins,
  PageAdmin,
} from '../pages/admins';
import {
  PageStudents,
} from '../pages/students';

const RouteUsers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/admins`} />
      </Route>
      <Route exact path={`${path}/admins`}>
        <PageAdmins />
      </Route>
      <Route exact path={`${path}/admins/:_id`}>
        <PageAdmin />
      </Route>
      <Route exact path={`${path}/students`}>
        <PageStudents />
      </Route>
    </Switch>
  );
};

export default RouteUsers;
